/**
 * Sets aria-disabled on the product form's submit button(s) when the acknowledgement
 * checkbox is unticked. Pairs with the CSS in component-acknowledgement.css that
 * visually styles the disabled state.
 *
 * We DO NOT touch the `disabled` attribute on the submit button — Dawn's product-form.js
 * uses that for its own state (variant sold out, loading), and overriding it here would
 * cause races. aria-disabled is purely semantic for assistive tech.
 */
(function () {
  const ackInputs = document.querySelectorAll('.acknowledgement__input[type="checkbox"]');
  if (!ackInputs.length) return;

  ackInputs.forEach((input) => {
    const formId = input.getAttribute('form');
    if (!formId) return;
    const form = document.getElementById(formId);
    if (!form) return;

    const submits = form.querySelectorAll('.product-form__submit, [type="submit"]');
    if (!submits.length) return;

    const sync = () => {
      submits.forEach((submit) => {
        if (input.checked) {
          submit.removeAttribute('aria-disabled');
        } else {
          submit.setAttribute('aria-disabled', 'true');
        }
      });
    };

    sync();
    input.addEventListener('change', sync);
  });
})();
